<div class="form-group mb-3">
  <label for="templateSelection">{{ 'workflow.documenttemplate' | translate }} *</label>
  <small>{{ 'workflow.documenttemplate_desc' | translate }}</small>
  <select [formControl]="template" class="form-control" id="templateSelection">
    <optgroup [label]="'workflow.documenttemplate_create_new' | translate">
      <option value="-1">{{ 'workflow.documenttemplate_create_new_option' | translate }}</option>
    </optgroup>
    <optgroup [label]="'workflow.documenttemplate_select' | translate">
      @if (!required) {
        <option [ngValue]="null">{{ 'workflow.no_documenttemplate' | translate }}</option>
      }
      @for (template of (documenttemplates$ | async); track template) {
        <option [ngValue]="template.documentTemplateUUID">{{ template.name }}</option>
      }
    </optgroup>
  </select>
</div>
